import axios from 'axios';
import { authHeader } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

export const getCartItems = () => axios.get(`${BASE_URL}/cart`, authHeader());
export const addToCart = (productId, quantity, optionId = null) =>
    axios.post(`${BASE_URL}/cart`, { productId, quantity, optionId }, authHeader());
export const updateCartItem = (cartId, quantity) =>
    axios.patch(`${BASE_URL}/cart/${cartId}`, { quantity }, authHeader());
export const deleteCartItem = (cartId) => axios.delete(`${BASE_URL}/cart/${cartId}`, authHeader());